<div class="modal-header px-5 pt-5">
    <h4 class="modal-title p-0" i18n>Carica Documenti</h4>
    <button type="button" class="btn-close" i18n-aria-label aria-label="Close"
        (click)="closeModal()"></button>
</div>

<div class="modal-body px-5 pb-5">
    <ngx-file-drop dropZoneLabel="Drop files here" dropZoneClassName="qai_dropzone"
        [accept]="acceptedFileTypes.join(', ')" contentClassName="qai_dropzone-content" (onFileDrop)="dropped($event)"
        [multiple]="true" [directory]="false">
        <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
            <p class="qai_upload-file-icon"><fa-icon class="px-2 pt-4" [icon]="faStickyNote"></fa-icon></p>
            <p class="qai_upload-arrow-icon text-primary"><fa-icon class="px-2" [icon]="faArrowUp"></fa-icon></p>
            <span i18n>Trascina qui i tuoi file o&nbsp;</span>
            <span class="fw-bolder text-primary" (click)="openFileSelector()" role="button" i18n>sfoglia</span>
        </ng-template>
    </ngx-file-drop>

    <ul class="list-group pt-3">
        @for (file of files; track file) {
        <li class="list-group-item border border-0 p-0 mb-2">
            <div class="container py-2">
                <div class="row align-items-center" style="height: 60px;">
                    @let fileNameNoExt = splitFileName(file.name)[0];
                    @let extension = splitFileName(file.name)[1];

                    <div class="col">
                        <app-file-icon [fileExtension]="extension"></app-file-icon>
                    </div>
                    <div class="col-10 py-2">
                        @let isErrorState =  fileStatus[file.name] === 'error' || fileStatus[file.name] === 'too-large';
                        
                        <span class="d-inline-block p-0 text-truncate align-middle"
                            [style.max-width]="'calc(100% - ' + (extension.length + 1) + 'ch)'"
                            [ngStyle]="{'color': fileStatus[file.name] === 'duplicate' || isErrorState ? 'gray' : 'black'}">
                            {{ fileNameNoExt }}
                        </span>
                        <span class="d-inline-block p-0 text-truncate align-middle"
                            [ngStyle]="{'color': fileStatus[file.name] === 'duplicate' || isErrorState ? 'gray' : 'black'}">
                            .{{ extension }}
                        </span>
                        @if (progress[file.name] > 0) {
                        <div class="progress" role="progressbar" i18n-aria-label
                            aria-label="Percentuale caricamento file" [attr.aria-valuenow]="progress[file.name]"
                            aria-valuemin="0" aria-valuemax="100" style="height: 5px">
                            <div class="progress-bar bg-primary" [style.width]="progress[file.name] + '%'"></div>
                        </div>
                        }
                    </div>
                    <div class="col">
                        @switch (fileStatus[file.name]) {
                        @case ('success') {
                        <fa-icon [icon]="faCircleCheck" style="color: green"></fa-icon>
                        }
                        @case ('error') {
                        <fa-icon [icon]="faExclamationTriangle" style="color: red" i18n-ngbTooltip
                            ngbTooltip="File non caricato" tooltipClass="qai-tooltip-danger"></fa-icon>
                        }
                        @case ('too-large') {
                        <fa-icon [icon]="faExclamationTriangle" style="color: red" i18n-ngbTooltip
                            ngbTooltip="Dimensione file oltre il limite consentito" tooltipClass="qai-tooltip-danger"></fa-icon>
                        }
                        @case ('duplicate') {
                        <fa-icon [icon]="faExclamationTriangle" style="color: orange" i18n-ngbTooltip
                            ngbTooltip="File già presente" tooltipClass="qai-tooltip-warning"></fa-icon>
                        }
                        @case ('uploading') {
                        <fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>
                        }
                        @default {
                        <fa-icon [icon]="faCircleXmark" (click)="removeFile(file)"></fa-icon>
                        }
                        }
                    </div>
                </div>
            </div>
        </li>
        }
    </ul>

    <p id="uploadHelp" class="form-text text-center" i18n>Formati supportati: TXT, PDF, HTML, DOCX, PPTX. Dimensione
        massima: 200 MB.</p>

    @if (errorMessage) {
    <div class="alert alert-danger text-center" role="alert">
        {{ errorMessage }}
    </div>
    }
</div>